<!-- 热门课程榜单列表-->
<template>
  <div :class="['hotSale-index', { inApp: $root.$data.isApp || $root.miniprogram }]">
    <common-title titleName="课程列表" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <template v-if="!listEmpty">
      <!-- <HotSaleSwiper
        v-if="hotList.length"
        :hotList="hotList"
      />-->

      <!-- 一级标签显示区域 -->
      <div
        :class="['course_classify_box',{ course_classify_box_inApp: $root.$data.isApp || $root.miniprogram }]"
      >
        <div
          :class="['course_classify_item',activeFirstLevelKey === item[0] ? 'course_classify_item_active' : '']"
          v-for="item in firstClassifyList"
          :key="item[0]"
          @click="onChangeFirstLevelCategory(item[0])"
        >
          {{ item[0] }}
        </div>
      </div>

      <!-- 二级标签显示区域 -->
      <div
        :class="['sub_category_box',{ sub_category_box_inApp: $root.$data.isApp || $root.miniprogram }]" 
        v-if="currentSecondLevelCategories && currentSecondLevelCategories.length > 0 && activeFirstLevelKey !== '全部'"
        >
        <div
          :class="['sub_category_item', activeSecondLevelKey === category ? 'sub_category_active' : '']"
          v-for="category in currentSecondLevelCategories"
          :key="category"
          @click="onChangeSecondLevelCategory(category)"
        >
          {{ category }}
        </div>
      </div>

      <div class="course_list">
        <div
          class="course_item"
          v-for="(item, index) in courseInfoData"
          :key="item.productId"
          @click="goDateil(item)"
        >
          <div class="course_content">
            <div class="course_img_box">
              <img class="course_img_cover" :src="item.coverMobile" alt />
              <img
                class="course_img_icon"
                v-if="index === 0 || index === 1 || index === 2"
                :src="`https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_coure_top${
                  index + 1
                }.png`"
                alt
              />
            </div>
            <div class="course_info">
              <div class="course_title">{{ item.name }}</div>
              <div class="course_tags">
                <TagComponent
                  v-for="(tagItem, tagIndex) in (item.discountLabelList || [])"
                  :key="tagIndex"
                  :text="tagItem"
                  :color="['套餐', '电子书'].includes(tagItem) ? 'blue' : 'yellow-no-bg'"
                />
              </div>
              <div class="course_time" v-if="item.startTime">
                上课时间 {{ item.startTime.slice(0, 10) }}
              </div>
            </div>
          </div>
          <div class="course_bottom">
            <img
              class="course_bottom_icon"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_shop_icon.png"
              alt
            />
            <div class="course_bottom_num">
              {{
                Number(item.setType == 1 ? item.actualSales : item.realSales) +
                Number(item.initialSales)
              }}人已购买
            </div>

            <!-- 划线价 -->
            <del
              v-if="
                (item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount) ||
                item.promotionLabel
              "
              class="course_line_price"
              >￥{{ item.originalPrice }}</del
            >

            <div class="course_price_box">
              <!-- 拼团价 -->
              <div
                class="course_price_tip"
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
              >
                拼团价
              </div>

              <!-- 促销价 -->
              <div class="course_price_tip" v-else-if="item.promotionLabel">
                {{
                  item.promotionLabel === 1
                    ? '折后价'
                    : item.promotionLabel === 4
                    ? '券后价'
                    : '限时价'
                }}
              </div>

              <!-- 价格icon -->
              <div
                class="course_price_icon"
                v-if="
                  (item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount) ||
                  !(item.sellPrice === 0 && !item.promotionLabel)
                "
              >
                ￥
              </div>

              <!-- 价格 -->
              <div
                class="course_price_num"
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
              >
                {{ item.productDiscountRespVO.discountMinPrice }}
              </div>

              <!-- 免费 -->
              <div class="course_price_free" v-else>
                {{ item.sellPrice === 0 && !item.promotionLabel ? '免费领取' : item.sellPrice }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="course-list">
        <h3 class="hotListTitle">课程榜单</h3>
        <div v-for="(item, keys) in courseInfoData" :key="keys" @click="goback()">
          <CombinationCard v-if="item.setType === 1" :key="keys" :item="item" />
          <HotCourseCard v-else :key="keys" :item="item" />
        </div>
      </div>-->
    </template>
    <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
    <Foot />
  </div>
</template>

<script>
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
// eslint-disable-next-line import/no-cycle
import { reqCombinationlist } from '@/api/combination';
// eslint-disable-next-line import/no-cycle
import { reqMajorAd, reqProducts, reqHotEvaluation, reqProductCategoryName } from '@/api/home';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import { resetProductData, resetCoursePackage } from '@/utils/tools';
import HotSaleSwiper from './components/hotSaleSwiper';
import TagComponent from '@/components/commonComponents/TagComponent.vue';

export default {
  data() {
    return {
      courseInfoData: [],
      ids: [],
      listEmpty: false,
      hotList: [],
      activeFirstLevelKey: '全部', // 一级标签的高亮状态
      activeSecondLevelKey: '', // 二级标签的高亮状态
      firstClassifyList: new Map([]),
      categoryList: [], //分类ids
      subCategoryMap: new Map(), // 存储一级标签与二级标签的映射关系
      currentFirstLevelCategory: '', // 当前选中的一级标签
      currentSecondLevelCategories: [], // 当前一级标签下的二级标签列表
    };
  },

  components: {
    HotCourseCard,
    CombinationCard,
    EmptyData,
    Foot,
    HotSaleSwiper,
    TagComponent,
  },

  computed: {},
  created() {
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0;
    document.body.scrollTop = 0;
  },
  mounted() {
    this.getProductEvaluation();
    this.getCourseAd();
    // if (this.$root.$data.isApp) {
    //   this.getCourseAd();
    // } else {
    //   const list = sessionStorage.getItem('HOTSALELIST');
    //   this.courseInfoData = JSON.parse(list);
    //   if (!this.courseInfoData.length) {
    //     this.listEmpty = true;
    //   }
    // }
    if (this.$root.miniprogram) {
      gio('track', 'PageAccess_event', {
        beforePageName_var: '课程页',
        functionName_var: '专享课列表',
        platform_var: '启航考研小程序',
      });
    }
  },
  destroyed() {},
  methods: {
    goDateil(item) {
      this.goback();
      if (item.setType === 1) {
        this.enterDetailsPack(item);
      } else {
        this.enterDetailsProd(item);
      }
      if (this.$root.miniprogram) {
        gio('track', 'xcxadShown_event', {
          adPosition_var: '专享轻学课',
          pageName_var: '课程',
          adId_var: this.$route.query.recommendId,
          adName_var: '',
          examType_var: this.$route.query.examType,
          courseName_var: item.name,
          platform_var: '启航考研小程序',
        });
      }
    },
    //处理一级标签切换
    onChangeFirstLevelCategory(firstLevelCategory) {
      this.activeFirstLevelKey = firstLevelCategory;
      this.currentFirstLevelCategory = firstLevelCategory;
      this.activeSecondLevelKey = '';
      
      // 如果选中的是"全部"，直接显示所有课程
      if (firstLevelCategory === '全部') {
        this.courseInfoData = this.firstClassifyList.get('全部') || [];
        this.currentSecondLevelCategories = [];
        return;
      }
      
      // 获取该一级标签下的所有课程
      this.courseInfoData = this.firstClassifyList.get(firstLevelCategory) || [];
      // 获取该一级标签下的二级标签列表
      const secondLevelMap = this.subCategoryMap.get(firstLevelCategory);
      if (secondLevelMap) {
        this.currentSecondLevelCategories = Array.from(secondLevelMap.keys());
        // 自动选中第一个二级标签
        if (this.currentSecondLevelCategories.length > 0) {
          this.activeSecondLevelKey = this.currentSecondLevelCategories[0];
          // 获取第一个二级标签下的所有课程
          this.courseInfoData = secondLevelMap.get(this.currentSecondLevelCategories[0]);
        }
      } else {
        this.currentSecondLevelCategories = [];
      }
    },

    //处理二级标签切换
    onChangeSecondLevelCategory(secondLevelCategory) {
      this.activeSecondLevelKey = secondLevelCategory;
      // 获取该二级标签下的所有课程
      const secondLevelMap = this.subCategoryMap.get(this.currentFirstLevelCategory);
      if (secondLevelMap && secondLevelMap.has(secondLevelCategory)) {
        this.courseInfoData = secondLevelMap.get(secondLevelCategory);
      } else {
        this.courseInfoData = [];
      }

     // console.log('二级标签切换:', secondLevelCategory, '课程列表:', this.courseInfoData);
    },
    goback() {
      sessionStorage.setItem('back', true);
    },
    // 获取热销产品评价轮播
    async getProductEvaluation() {
      const res = await reqHotEvaluation();
      this.hotList = res?.data?.data;
    },
    // 查询广告位
    async getCourseAd() {
      const { code, data } = await reqMajorAd(this.$route.query.recommendId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      } else {
        this.listEmpty = true;
      }
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || []);
        const resPackage = resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          if (findRes) {
            const { productCategoryId, categoryId } = findRes;
            const cateIdS = child.recommendType === 0 ? productCategoryId : categoryId;
            if (cateIdS) {
              // 使用Set去重，避免重复添加相同的cateIdS
              const uniqueCategoryIds = [...new Set([...this.categoryList, cateIdS])];
              this.categoryList = uniqueCategoryIds;
            }
            if (this.$root.miniprogram) {
              gio('track', 'xcxadShown_event', {
                adPosition_var: '专享轻学课',
                pageName_var: '课程',
                adId_var: this.$route.query.recommendId,
                adName_var: '',
                examType_var: this.$route.query.examType,
                courseName_var: child.name,
                platform_var: '启航考研小程序',
              });
            }
          }
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse;
        this.getCategoryList();
      });
    },

    //数据初始化
    async getCategoryList() {
      const ids = this.categoryList.map((id) => `ids=${id}`).join('&');
      let res = await reqProductCategoryName(ids, '/');
      if (res && res.data) {
        // 从API返回的数据中提取并处理分类信息
        const categoryNames = this.extractAndProcessCategories(res.data);

        // 处理完分类数据后，默认选择"全部"选项
        this.$nextTick(() => {
          if (categoryNames.length > 0) {
            // 默认选择"全部"选项，此时会自动选中第一个二级标签
            this.onChangeFirstLevelCategory('全部');
          }
        });
      }
    },
   //从API返回的数据中提取并处理分类信息
    extractAndProcessCategories(categories) {
      const firstLevelMap = new Map();
      const allSecondLevelMap = new Map();
      categories.forEach((category) => {
        if (category.nameWrap) {
          const pathParts = category.nameWrap.split('/');
          // 提取一级标签（倒数第二级）和二级标签（最后一级）
          if (pathParts.length >= 2) {
            const firstLevel = pathParts[pathParts.length - 2]; 
            const secondLevel = pathParts[pathParts.length - 1]; 

            let courseContent = [];
            this.courseInfoData.forEach((course) => {
              if (course.productCategoryId === category.id || course.categoryId === category.id) {
                courseContent.push(course);
              }
            });

            // 如果找到匹配的课程内容，则添加到一级标签下
            if (courseContent.length > 0) {
              if (!firstLevelMap.has(firstLevel)) {
                firstLevelMap.set(firstLevel, []);
              }
              firstLevelMap.get(firstLevel).push(...courseContent);
            }

            // 处理二级标签映射关系
            if (!this.subCategoryMap.has(firstLevel)) {
              this.subCategoryMap.set(firstLevel, new Map());
            }

            const secondLevelMap = this.subCategoryMap.get(firstLevel);
            if (!secondLevelMap.has(secondLevel)) {
              secondLevelMap.set(secondLevel, []);
            }

            // 将课程内容添加到二级标签下
            if (courseContent.length > 0) {
              secondLevelMap.get(secondLevel).push(...courseContent);
            }
            
            // 收集所有二级标签，用于"全部"选项
            if (!allSecondLevelMap.has(secondLevel)) {
              allSecondLevelMap.set(secondLevel, []);
            }
            if (courseContent.length > 0) {
              allSecondLevelMap.get(secondLevel).push(...courseContent);
            }
          }
        }
      });
      this.firstClassifyList.set('全部', this.courseInfoData);
      this.subCategoryMap.set('全部', allSecondLevelMap);

      // 然后将处理好的分类数据添加到firstClassifyList中
      firstLevelMap.forEach((courses, category) => {
        if (!this.firstClassifyList.has(category)) {
          this.firstClassifyList.set(category, courses);
        }
      });

      //console.log('处理后的分类数据:', this.firstClassifyList);
      //console.log('二级标签映射关系:', this.subCategoryMap);
      return ['全部', ...firstLevelMap.keys()];
    },

    // 产品进入详情
    enterDetailsProd(courseInfo) {
      const { productSkipConfigRespVO, productId } = courseInfo;
      const { query } = this.$route;
      // 判断是否App
      if (this.$root.$data.isApp) {
        if (productSkipConfigRespVO?.source === 1 && productSkipConfigRespVO?.skipType === 0) {
          // 外部产品
          this.$sendToApp('openBrowser', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else if (
          // 淘宝产品
          productSkipConfigRespVO?.source === 1 &&
          productSkipConfigRespVO?.skipType === 1
        ) {
          this.$sendToApp('openTaobao', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else {
          this.$sendToApp('goCourseDetail', Number(productId), false);
        }
        return;
      }
      if (productSkipConfigRespVO?.source === 1) {
        // 外部产品
        window.open(productSkipConfigRespVO?.mobileSkipUrl);
        return;
      }
      const { roomId } = this.$route.query;
      if (roomId) {
        // 直播间内的推荐课程
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
            liveRoomId: roomId,
            beforePageName: 6,
          },
        });
        // window.open(`${window.location.origin}/ark/courseDetail?courseId=${productId}&liveRoomId=${roomId}&beforePageName=6`)
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
            beforePageName: 6,
            ...query,
          },
        });
      }
    },

    // 套餐进入详情
    enterDetailsPack(courseInfo) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToCombinationCourse', Number(courseInfo.packageId), false);
        return;
      }
      const { roomId } = this.$route.query;
      const { query } = this.$route;
      if (roomId) {
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: courseInfo.packageId,
            liveRoomId: roomId,
          },
        });
      } else {
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: courseInfo.packageId,
            ...query,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  height: 0;
}
::v-deep .commonTitle {
  position: fixed;
  right: 0;
  left: 0;
  width: 750px;
  margin: 0 auto;
}
.hotSale-index {
  width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding-top: 191px;
  font-family: PingFangSC, PingFang SC, sans-serif;
  background: #f7f8fc;
  &.inApp {
    padding-top: 95px;
  }

  .course-list {
    padding: 40px;
    .hotListTitle {
      margin-bottom: 32px;
      color: #111;
      font-weight: 500;
      font-size: 32px;
      line-height: 44px;
    }
  }

  .course_classify_box {
    position: fixed;
    top: 100px;
    right: 0;
    left: 0;
    z-index: 6;
    display: flex;
    gap: 45px;
    width: 750px;
    height: 91px;
    margin: 0 auto;
    padding: 0 36px;
    overflow-x: auto;
    background: #fff;

    .course_classify_item {
      flex-shrink: 0;
      height: 91px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 91px;
    }

    .course_classify_item_active {
      color: #ff7f41;
    }

    .course_classify_item_active::after {
      position: relative;
      bottom: 7px;
      left: 50%;
      display: block;
      width: 29px;
      height: 7px;
      background: #ff7f41;
      transform: translateX(-50%);
      content: '';
    }
  }

  .course_classify_box_inApp {
    top: 0;
  }

  .course_list {
    min-height: calc(100vh - 192px);
    padding: 29px 36px 0;
    // min-height: 100vh;
    .course_item {
      width: 678px;
      height: 239px;
      margin-bottom: 22px;
      overflow: hidden;
      background: #fff;
      border: 1px solid #f1d8b8;
      border-radius: 14px;

      .course_content {
        width: 100%;
        height: 173px;
        overflow: hidden;

        .course_img_box {
          position: relative;
          float: left;
          width: 188px;
          height: 136px;
          margin-top: 20px;
          margin-left: 18px;

          .course_img_cover {
            width: 100%;
            height: 100%;
            border-radius: 11px;
          }
          .course_img_icon {
            position: absolute;
            top: 0;
            right: 0;
            width: 94px;
            height: 29px;
          }
        }

        .course_info {
          float: left;
          width: 438px;
          margin-top: 18px;
          margin-left: 14px;

          .course_title {
            display: -webkit-box;
            width: 438px;
            overflow: hidden;
            color: #333;
            font-weight: 500;
            font-size: 25px;
            font-family: PingFangSC, PingFang SC, sans-serif;
            line-height: 33px;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          .course_tags {
            display: flex;
            gap: 7px;
            height: 29px;
            margin-top: 9px;

            .course_tag {
              // width: 69px;
              height: 29px;
              padding: 0 7px 0;
              color: #fff;
              font-weight: 400;
              font-size: 18px;
              line-height: 29px;
              background: #ff7f41;
              border-radius: 5px;
            }
          }

          .course_time {
            height: 25px;
            // line-height: 25px;
            margin-top: 18px;
            color: #999;
            font-weight: 400;
            font-size: 18px;
            font-family: PingFangSC, PingFang SC, sans-serif;
          }
        }
      }
      .course_bottom {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 64px;
        background: #fff9e9;
        border: 1px solid #f1d8b8;
        border-radius: 0 0 14px 14px;

        .course_bottom_icon {
          display: block;
          width: 29px;
          height: 29px;
          margin-left: 18px;
        }
        .course_bottom_num {
          height: 31px;
          margin-left: 7px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          line-height: 31px;
        }

        .course_line_price {
          position: absolute;
          top: 18px;
          right: 249px;
          height: 31px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          font-family: PingFangSC, PingFang SC, sans-serif;
          line-height: 31px;
        }

        .course_price_box {
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 243px;
          height: 65px;
          background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_price_bkg.png')
            no-repeat;
          background-size: cover;

          .course_price_tip {
            height: 25px;
            color: #fff;
            font-weight: 500;
            font-size: 18px;
            font-family: PingFangSC, PingFang SC, sans-serif;
            line-height: 33px;
          }

          .course_price_icon {
            height: 25px;
            color: #fff;
            font-weight: 500;
            font-size: 25px;
            font-family: PingFangSC, PingFang SC, sans-serif;
            line-height: 33px;
          }

          .course_price_num {
            height: 51px;
            color: #fff;
            font-weight: 500;
            font-size: 36px;
            font-family: PingFangSC, PingFang SC, sans-serif;
            line-height: 51px;
          }

          .course_price_free {
            height: 40px;
            color: #fff;
            font-weight: 500;
            font-size: 29px;
            font-family: PingFangSC, PingFang SC, sans-serif;
            line-height: 40px;
          }
        }
      }
    }
  }
}
.sub_category_box {
  display: flex;
  flex-wrap: wrap;
  gap:0 20px;
  padding: 0 36px;
  .sub_category_item {
    margin-top: 20px;
    padding: 12px 30px;
    color: #666;
    font-weight: 400;
    font-size: 25px;
    text-align: center;
    background: #fff;
    border: 2px solid #f1f1f1;
    border-radius: 27px;
  }
}
.sub_category_active{
  color: #fff !important;
  background: #ff6c02 !important;

}

::v-deep .topType {
  display: none;
}

::v-deep .common-foot {
  position: relative;
}
</style>
